import { useState, useEffect } from "react";
import Context from "shared/util/Context";
import { AUTHED_ROUTES } from "routers/shared/util/consts";
import QuickmatchActions from "reflux/quickmatch/actions/Actions";
import ActionUtil from "shared/util/ActionUtil";

export const canShowGlobalPreferenceTooltip = (pathname) => {
	const isDoubleTake = AUTHED_ROUTES.Doubletake.includes(pathname);

	return isDoubleTake && Context.has("GLOBAL_PREFERENCES");
};

export const useRefluxPassCount = () => {
	const [refluxPassCount, setRefluxPassCount] = useState(0);

	useEffect(() => {
		ActionUtil.spy(
			QuickmatchActions.vote,
			({ like }) => {
				if (!like) {
					setRefluxPassCount((prev) => prev + 1);
				}
			},
		);
	}, []);

	return refluxPassCount;
};



// WEBPACK FOOTER //
// ./src/shared/components/GlobalPreferenceTooltip/helpers.js